import useWindowSize from './useWindowSize';


/**
 * A hook for checking if the window is above a given size.
 * @param breakSize The width comparing against (see index.css for standard break sizes otherwise use any size)
 * @return True if the width is above or equal the passed in size.
 */
export function useScreenSizeAtAndAbove(breakSize) {
  const [width] = useWindowSize();
  return width >= breakSize;
}

/**
 * A hook for checking if the window is below a given size.
 * @param breakSize The width comparing against (see index.css for standard break sizes otherwise use any size)
 * @return True if the width is below the passed in size.
 */
export function useScreenSizeBelow(breakSize) {
  const [width] = useWindowSize();
  return width < breakSize;
}
